<app-field-label [label]="labelKey() | translate" [required]="required()"></app-field-label>
<mat-form-field appearance="outline" class="w-100">
    @if (districtMode() === DISTRICT_MODE.State) {
        <mat-select [panelClass]="'custom-option-list'" disableOptionCentering [formControl]="control()">
            @if (!required()) {
                <mat-option [value]="''"> </mat-option>
            }
            @for (state of states; track state) {
                <mat-option [value]="state">{{ state }}</mat-option>
            }
        </mat-select>
    } @else {
        <input matInput trim="blur" type="text" [formControl]="control()" [maxlength]="maxLength()" />
    }
    @if (control().invalid) {
        <mat-error>
            <app-invalid-label [label]="labelKey() | translate"></app-invalid-label>
        </mat-error>
    }
</mat-form-field>
